import {Injectable} from '@angular/core';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import {Observable} from 'rxjs';
import {Dictionary} from '@common_libraries/helpers/Dictionary';
import {
  UserActivityBreakdownStats,
  UserActivityBrowserStats, UserActivityDetails,
  UserActivityOSStats
} from './sys-admin-user-activity.service.models';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SysAdminUserActivityService {
  public constructor(private servLib: ServiceLibrary) {
  }

  UserActivityDetails(timeFrameOption: number): Observable<Array<UserActivityDetails>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/UserActivityDetails', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  BrowserStats(timeFrameOption: number): Observable<Array<UserActivityBrowserStats>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/BrowserStats', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  OsStats(timeFrameOption: number): Observable<Array<UserActivityOSStats>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/OsStats', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  DailyStats(timeFrameOption: number): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/DailyStats', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  WeeklyStats(timeFrameOption: number): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/WeeklyStats', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  HourlyStats(timeFrameOption: number): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/user/' + timeFrameOption + '/HourlyStats', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  UserActivityDetailsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityDetails>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/UserActivityDetailsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  BrowserStatsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityBrowserStats>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/BrowserStatsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  OsStatsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityOSStats>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/OsStatsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  DailyStatsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/DailyStatsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  WeeklyStatsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/WeeklyStatsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  HourlyStatsByUserID(timeFrameOption: number, UserID: string): Observable<Array<UserActivityBreakdownStats>> {
    const parameters = new Dictionary([]);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/' + timeFrameOption + '/HourlyStatsByUserID', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  GetUserActivityExportToken(TimeFrameOptionID: number, UserID: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('TimeFrameOptionID', TimeFrameOptionID);
    parameters.add('UserID', UserID);

    return this.servLib.HttpPost('/v1/api/user/GenerateActivityExportToken', ServiceLibrary.ContentType.JSON, parameters);
  }

  InsertUserActivity(url: string, browser: string, os: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('URL', url);
    parameters.add('Browser', browser);
    parameters.add('OS', os);

    return this.servLib.HttpPost('/v1/api/user/InsertActivity', ServiceLibrary.ContentType.JSON, parameters);
  }
}
